// assets
import { IconKey, IconPalette, IconShadow, IconWindmill,IconLogout } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconLogout
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
    id: 'utilities',
    title: 'Seguridades',
    type: 'group',
    children: [
        {
            id: 'util-typography',
            title: 'Cambio de Clave',
            type: 'item',
            url: '/utils/util-typography',
            icon: icons.IconKey,
            breadcrumbs: false
        },
        {
            id: 'util-color',
            title: 'Cerrar sesión',
            type: 'item',
            url: '/',
            icon: icons.IconLogout,
            breadcrumbs: false
        },
        
    
    ]
};

export default utilities;